import compact from 'lodash/compact'

import baseTheme from 'theme'
import media from 'media'

import { Container as SimplePostSummaryContainer } from 'components/summaryCards/SimplePostSummary'
import { StyledArrowLink } from 'components/ArrowLink'
import { CLASS_NAME as BUTTON_CLASS_NAME } from 'components/Button'
import { PILL_CLASS_NAME } from 'components/Pill'
// probably dont need ButtonStyled from ui package...
import { ButtonStyled } from '@anvilco-pkg/ui/components/Button'

import { getMobileBodyFontSize, getDesktopBodyFontSize } from 'helpers'

import { CLASS_NO_LINK_STYLES, CLASS_STYLE_AS_LINK } from 'consts'

export const HIGHLIGHT_COLOR = '#ADE1EB'

export const getBackgroundStyles = ({ background, theme }) => {
  const styles = [background ? `background: ${background};` : '']
  // NOTE: these default colors are for a LIGHT mode - we could/should support a DARK mode one day,
  // but until then we'll default to LIGHT (which is just white background) and then the section
  // background overrides below
  let linkColor = theme?.textColors?.link || baseTheme.colors.black
  let linkHoverColor =
    theme?.textColors?.linkHover || baseTheme.textColors.linkHover

  switch (background) {
    case baseTheme.colors.black:
      linkColor = baseTheme.colors.white
      linkHoverColor = baseTheme.colors.white
      break
    case baseTheme.colors.blacks[5]:
    case baseTheme.colors.blacks[10]:
      linkColor = baseTheme.colors.linkColor.light
      linkHoverColor = baseTheme.colors.black
      break
    case baseTheme.colors.blacks[70]:
      linkColor = baseTheme.colors.linkColor.dark
      linkHoverColor = baseTheme.colors.white
      styles.push(
        `color: ${baseTheme.colors.white};
        h1, h2, h3, h4, h5, h6 {
            color: white;
        }`
      )
      break
    case baseTheme.colors.blues[5]:
    case baseTheme.colors.blues[10]:
    case baseTheme.colors.blues[20]:
    case baseTheme.colors.blues[25]:
      linkColor = baseTheme.colors.black
      linkHoverColor = baseTheme.colors.greens[60]
      styles.push(
        `& ::selection {
            background: ${baseTheme.colors.black};
            color: ${baseTheme.colors.white};
        }
        
        .${BUTTON_CLASS_NAME}[type="outline-default"] {
            path {
              fill: ${baseTheme.colors.greens[60]};
            }
        }`
      )
      break
    case baseTheme.colors.greens[5]:
    case baseTheme.colors.greens[10]:
    case baseTheme.colors.greens[20]:
      linkColor = baseTheme.colors.black
      linkHoverColor = baseTheme.colors.blues[60]
      break
    case baseTheme.colors.yellows[5]:
    case baseTheme.colors.yellows[10]:
    case baseTheme.colors.yellows[20]:
      linkColor = baseTheme.colors.black
      linkHoverColor = baseTheme.colors.blues[60]
      break
    case baseTheme.colors.gray:
      break
    default:
      styles.push(
        `background: white;
        & ::selection {
            background: ${HIGHLIGHT_COLOR};
            color: ${baseTheme.colors.black};
        }`
      )
  }

  return { styles: compact(styles).join('\n'), linkColor, linkHoverColor }
}

export const getModeStyling = ({ mode, theme, isSubSection, background }) => {
  const {
    styles: backgroundStyles,
    linkColor,
    linkHoverColor,
  } = getBackgroundStyles({ background, theme })

  return `
    ${backgroundStyles}

    .${CLASS_NO_LINK_STYLES} {
        color: ${baseTheme.colors.black};

        :hover {
            text-decoration: none;
        }
    }
  
    // :where is used here to reduce specificity to 0 - if we want to override these styles, it should be easy to do so
    // TODO: Section and SubSection both use this. ideally: Section is the most overrideable, SubSection is less so, and then
    // the elements within SubSection are the least overrideable - they take precedence over the Section and SubSection
    // all without using !important or increasing specificity via &&&&&&. But, for now we'll just use && for SubSection
    ${
      isSubSection ? `&& ` : ''
    } a:where(:not(.btn):not([name]):not(${ButtonStyled}):not(.${BUTTON_CLASS_NAME}):not(${StyledArrowLink}):not(${SimplePostSummaryContainer}):not(.${CLASS_NO_LINK_STYLES}):not(.${PILL_CLASS_NAME})),
    .${CLASS_STYLE_AS_LINK} {
      background: transparent;
      box-shadow: none;
      text-decoration: underline;
      color: ${linkColor};
      font-weight: ${baseTheme.fontWeights.bold};

      :hover {
        color: ${linkHoverColor};
      }
    }

    .${CLASS_STYLE_AS_LINK} {
      padding: 0;
      font-size: ${getMobileBodyFontSize({ theme })};
      ${media.desktop`
        font-size: ${getDesktopBodyFontSize({ theme })};
      `}
    }
  `
}
